var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.$store.state.LOADING),expression:"$store.state.LOADING"}],staticClass:"loading"},[_c('img',{attrs:{"src":_vm.loading}}),_vm._v(" "),_c('p',{staticStyle:{"font-size":"14px","color":"#999"}},[_vm._v("正在加载...")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fc5a099c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/packages/loading/showloading.vue
// module id = DwOm
// module chunks = 5